import { getAllData } from "apis/customApiHandler";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import axios from "apis/axios";
import ReactSelect from "react-select";
import Spinner from "components/Spinner";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Modal from "components/Modal";

const DailyInspectionReport = () => {
  const ids = window.location.search.split("=")[1];
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [contractType, setContractType] = useState("All");
  const [alignment, setAlignment] = useState("All");
  const [rotation, setRotation] = useState("All");
  const [replacement, setReplacement] = useState("All");
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getData = async (pg)=>{
    setIsLoading(true)
    const dt = await  getAllData("/report/inspectionreport", {
            ...(selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
            ...(selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
            ...(ids && {
              ids,
            }),
            ...(searchQuery && { searchQuery }),
            ...(contractType !== "All" && contractType !== "" && { contractType }),
          });
    // console.log(dt)
    setData(dt);
    setIsLoading(false)
  }
  useEffect(()=>{
    getData(page);
  }, [page])
  
//   const { data: allFleets } = useQuery([`/customer-fleet`], () =>
//     getAllData("/customer-fleet", {
//       limit: 250,
//     })
//   );
//   const { data: allHubs } = useQuery([`/customer-hub`], () =>
//     getAllData("/customer-hub", {
//       limit: 250,
//     })
//   );

//   const getDownloadData = async ()=>{
//     setDownloading(true)
//     const dt = await getAllData("/report/stockReport", {
//       ...(selectedFleets.length && {
//         fleets: selectedFleets.map((fleet) => fleet).join(","),
//       }),
//       ...(selectedHubs.length && {
//         hubs: selectedHubs.map((hub) => hub).join(","),
//       }),
//       ...(ids && {
//         ids,
//       }),
//       ...(searchQuery && { searchQuery }),
//       ...(contractType !== "All" && contractType !== "" && { contractType }),
//       dateFrom,
//       dateTo,
//     });
//     // console.log(dt)
//     let xld = [] 
//     dt?.data?.data && dt.data.data[0]?.map((x, idx) => {
//       xld.push({
//       "S.N": idx + 1,
//       "Mobility": x.fleet,
//       "Owner": x?.isGrnTyre,
//       "On Wheel": x?.fitted,
//       "Reusable": x?.reusable,
//       "Scrap": x?.scrap,
//       "New Tyre": x?.newTyre,
//       "Casing": x?.casing,
//       "Greater than 8": x?.greaterThan8,
//       "Between 4 and 8": x?.between4And8,
//       "Less than 4": x?.lessThan4,
//       "Total": x?.total,
//     })}
//     )
//     dt?.data?.data && dt.data.data[1]?.map((x, idx) => {
//       xld.push({
//       "S.N": dt?.data?.data[0].length + idx + 1,
//       "Mobility": x.fleet,
//       "Owner": x?.isGrnTyre,
//       "On Wheel": x?.fitted,
//       "Reusable": x?.reusable,
//       "Scrap": x?.scrap,
//       "New Tyre": x?.newTyre,
//       "Casing": x?.casing,
//       "Greater than 8": x?.greaterThan8,
//       "Between 4 and 8": x?.between4And8,
//       "Less than 4": x?.lessThan4,
//       "Total": x?.total,
//     })
//   })
//     exportExcel(
//       xld,
//       "DailyInspectionReport.xlsx"
//     );
//     setDownloading(false);
//   }

//   const getFleetOptions = useCallback(() => {
//     if (allFleets && allFleets.data && allFleets.data.length) {
//       return [
//         {
//           label: "Select All",
//           value: "all",
//         },
//         ...allFleets?.data?.map((fleet) => {
//           return {
//             value: fleet._id,
//             label: fleet.fleetName,
//           };
//         }),
//       ];
//     }
//   }, [allFleets]);

//   const getHubOptions = useCallback(() => {
//     if (allHubs && allHubs.data && allHubs.data.length) {
//       return [
//         selectedFleets?.length && {
//           label: "Select All",
//           value: "all",
//         },
//         ...(allHubs?.data?.length &&
//           allHubs?.data
//             ?.filter((hub) => {
//               const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
//                 selectedFleets?.includes(fleet._id)
//               );

//               return selectedFleetsVal?.some(
//                 (fleet) => fleet.fleetCode === hub.fleetCode
//               );
//             })
//             ?.map((hub) => {
//               return {
//                 value: hub._id,
//                 label: hub.hubName,
//               };
//             })),
//       ];
//     }
//   }, [allFleets, allHubs, selectedFleets]);

const array = ["CPKM", "Service Contract"]

  return (
    <div>
      {/* <div className="flex flex-col text-gray-500">
        <div className="w-full px-8 flex justify-center items-center gap-4">
          <label className="w-full py-3">
            Select Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: allFleets?.data?.find((item) => item?._id === fleet)
                      ?.fleetName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);

                if (allValues.includes("all")) {
                  setSelectedFleets(
                    allFleets?.data?.map((item) => {
                      return item._id;
                    })
                  );
                } else {
                  let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedHubsVal = allHubs?.data?.filter((hub) =>
                    selectedHubs?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedHubs(
                    selectedHubsVal
                      ?.filter((hub) =>
                        selectedFleetsVal?.find(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        )
                      )
                      .map((hub) => hub._id)
                  );

                  setSelectedFleets(value.map((fleet) => fleet.value));
                }
              }}
              name="fleets"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  return {
                    value: hub,
                    label: allHubs?.data?.find((item) => item._id === hub)
                      ?.hubName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);

                if (allValues.includes("all")) {
                  setSelectedHubs((pre) =>
                    allHubs?.data
                      ?.filter((hub) => {
                        const selectedFleetsVal = allFleets?.data?.filter(
                          (fleet) => selectedFleets?.includes(fleet._id)
                        );
                        return selectedFleetsVal?.some(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        );
                      })
                      ?.map((hub) => hub._id)
                  );
                } else {
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

          <Button type="button" bgPrimary onClick={()=>getData(1)}>
            Search
          </Button>


        </div>
        <div className="w-full px-8 flex justify-start items-center gap-4">

          
        </div>
      </div> */}

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {data.data&& (
            <div className="flex flex-col m-2 lg:m-10">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col"></TH>
                          <TH scope="col">  </TH>
                          <TH scope="col">Inspection Today</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">1-15</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">16-30</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">31-60</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">Above 60</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">Pending</TH>
                          <TH scope="col"></TH>
                          <TH scope="col">Fitment Today</TH>
                          <TH scope="col"></TH>

                        </tr>
                        <tr>
                        <TH scope="col">S.N.</TH>
                          <TH scope="col">Mobility</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                          <TH scope="col">CPKM</TH>
                          <TH scope="col">Service Contract</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {Object.keys(data?.data).map((key, index)=>{
                            return <tr>
                                <TD> {index + 1} </TD>
                                <TD> {data?.fleetCityMap?.[key] ? `${key} (${data.fleetCityMap[key]})` : key} </TD>
                                {data?.data[key] && Object.keys(data?.data[key]).map(subKey=>{
                                    console.log(data.data[key][subKey])
                                    return data.data[key][subKey]!==undefined && array.map(subSubKey=>{
                                      console.log(subSubKey, data?.data[key][subKey][subSubKey])  
                                      return <TD>{data?.data[key][subKey][subSubKey]!== undefined ? data?.data[key][subKey][subSubKey]: 0}</TD>
                                    })
                                    // return <TD> {" "} {data?.data[key][subKey]["CPKM"]} &nbsp; | &nbsp; {data?.data[key][subKey]["Service Contract"]} {" "}</TD>
                                     {/* <TD></TD> */}
                                    // </TD>
                                })}
                            </tr>
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DailyInspectionReport;

